/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolEcgHeartIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-ecg-heart"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M16.13 2.67Q18.7 2.67 20.51 4.6Q22.32 6.53 22.32 9.25Q22.32 9.7 22.27 10.14Q22.23 10.57 22.1 11L15.53 11L13.82 8.45Q13.7 8.25 13.47 8.13Q13.25 8 13 8Q12.68 8 12.41 8.2Q12.15 8.4 12.05 8.7L10.7 12.75L9.82 11.45Q9.7 11.25 9.47 11.13Q9.25 11 9 11L1.88 11Q1.75 10.57 1.71 10.15Q1.68 9.72 1.68 9.28Q1.68 6.53 3.48 4.6Q5.28 2.67 7.85 2.67Q8.97 2.67 10.05 3.11Q11.13 3.55 12 4.35L12 4.35L12 4.35Q12.85 3.55 13.91 3.11Q14.97 2.67 16.13 2.67ZM12 21.32Q11.47 21.32 11 21.13Q10.53 20.93 10.18 20.57L3.48 13.85Q3.27 13.65 3.1 13.44Q2.92 13.22 2.77 13L8.45 13L10.15 15.55Q10.28 15.75 10.5 15.88Q10.72 16 10.97 16Q11.3 16 11.57 15.8Q11.85 15.6 11.95 15.3L13.3 11.25L14.15 12.55Q14.3 12.75 14.53 12.88Q14.75 13 15 13L21.2 13Q21.05 13.22 20.89 13.43Q20.73 13.63 20.52 13.82L13.8 20.57Q13.45 20.93 12.97 21.13Q12.5 21.32 12 21.32Z" fill={color} />
    </svg>
  );
}
